import React from "react";
import irluxe from "./../images/irluxe.svg";
import styles from "./Top.module.css";

const Top = () => {
  return (
    <div className="top">
      <div className={styles.container}>
        <div className={styles.containerirluxe}>
          <img className={styles.irluxepic} src={irluxe} />
        </div>
        <h1 className={styles.irluxe}>ایرلوکس</h1>
        <h3 className={styles.irluxedesc}>زیبایی | ظرافت | تخصص</h3>
      </div>
      <div className={styles.scrolldown}>
        <div className={styles.insco}>
        <i className="fa-regular fa-chevron-down"></i>
        <div className={styles.text}>
          به پایین بکشید!
          </div>
         
        </div>
      </div>
    </div>
  );
};

export default Top;
